// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"a1124c295090bb91da2464682989917eb453f40f"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import { isDev } from "@/helpers";

if (!isDev()) {
  Sentry.init({
    dsn: "https://2cfb12832a657cefc2cb44de44527018@o4508348324380672.ingest.us.sentry.io/4508348331065344",

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,

    // Enable debugging in non-production environments
    debug: process.env.NODE_ENV !== "production",

    // Ensure the client sends source maps
    autoSessionTracking: true,
    sendClientReports: true,
    includeLocalVariables: true, // Incluir variáveis locais no stacktrace
    attachStacktrace: true, // Anexar stacktrace para todos os eventos

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10% while
    // in production to avoid excessive data
    replaysSessionSampleRate: 0.1,

    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true
      }),
      // Adiciona integração de rastreamento automático
      Sentry.browserTracingIntegration()
    ],

    // Capture router transition spans for performance monitoring
    // This is relevant for Next.js app using App Router
    beforeSend(event) {
      // Utilizado para garantir rastreabilidade
      if (event.exception && event.exception.values) {
        event.exception.values.forEach((exception) => {
          if (exception.stacktrace?.frames) {
            exception.stacktrace.frames = exception.stacktrace.frames.filter(
              (frame) => !frame.filename?.includes("node_modules")
            );
          }
        });
      }
      return event;
    }
  });
}
